import { Component, OnInit, Input, ChangeDetectorRef, } from '@angular/core';
import { FormRowComponent } from "./form-row/form-row.component";
import { Form } from "../../../@core/data/form"
import { FormService } from "../../../@core/api/form.service"
import { NbWindowService, NbWindowState } from '@nebular/theme';
import { LenguageService } from '../../../@core/utils/lenguage.service'
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-forms-table',
  templateUrl: './forms-table.component.html',
  styleUrls: ['./forms-table.component.scss']
})
export class FormsTableComponent implements OnInit {

  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  forms: Form[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0
  }
  order = {
    field: "timestamp",
    direction: "desc"
  }
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number,
    dateEnd: number,
  }

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private formService: FormService,
    public language: LenguageService
  ) {

  }

  async ngOnInit() {

    this.getForms();

  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getForms();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getForms();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getForms() {
    this.loading = true;
    this.forms = <Form[]>await this.formService.getForms(this.pagination, this.filters, this.order);
    this.loading = false;

    if (this.forms.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }

  }


  async createForm() {
    this.loading = true;
    this.loading = false;
    this.router.navigate(["home","form"])

  }

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = new Date(this.range.start).getTime() * 1000 / 1000;
    this.filters.dateRange = { dateStart, dateEnd };

  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getForms();
  }

}
